import { z } from "zod";

import type { DbEntity } from "../../../../client";

/**
 * Shared response schemas for document templates
 */

/**
 * Single document template response
 */
export const DocumentTemplateResponseSchema = z.custom<DbEntity.DocumentTemplate>(
  (data): data is DbEntity.DocumentTemplate => {
    return (
      typeof data === "object" &&
      data !== null &&
      "id" in data &&
      typeof data.id === "string" &&
      "name" in data &&
      typeof data.name === "string"
    );
  },
  {
    message: "Invalid document template response: missing required fields"
  }
);

/**
 * Document template list response with pagination
 */
export const DocumentTemplateListResponseSchema = z.object({
  templates: z.array(
    z.custom<DbEntity.DocumentTemplate>(
      (data) => typeof data === "object" && data !== null && "id" in data
    )
  ),
  total: z.number().int().min(0)
});
